export default [
    {
        "code": "395",
        "description": "Moderate or heavy snow in area with thunder",
        "day_icon": "wi_day_snow_thunderstorm",
        "night_icon": "wi_night_snow_thunderstorm"
    },
    {
        "code": "392",
        "description": "Patchy light snow in area with thunder",
        "day_icon": "wi_day_sleet_storm",
        "night_icon": "wi_night_sleet_storm"
    },
    {
        "code": "389",
        "description": "Moderate or heavy rain in area with thunder",
        "day_icon": "wi_day_thunderstorms",
        "night_icon": "wi_night_thunderstorm"
    },
    {
        "code": "386",
        "description": "Patchy light rain in area with thunder",
        "day_icon": "wi_day_thunderstorms",
        "night_icon": "wi_night_thunderstorm"
    },
    {
        "code": "377",
        "description": "Moderate or heavy showers of ice pellets",
        "day_icon": "wi_day_sleet_storm",
        "night_icon": "wi_night_sleet_storm"
    },
    {
        "code": "374",
        "description": "Light showers of ice pellets",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "371",
        "description": "Moderate or heavy snow showers",
        "day_icon": "wi_day_snow",
        "night_icon": "wi_night_snow"
    },
    {
        "code": "368",
        "description": "Light snow showers",
        "day_icon": "wi_day_snow",
        "night_icon": "wi_night_snow"
    },
    {
        "code": "365",
        "description": "Moderate or heavy sleet showers",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "362",
        "description": "Light sleet showers",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "359",
        "description": "Torrential rain shower",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "356",
        "description": "Moderate or heavy rain shower",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "353",
        "description": "Light rain shower",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "350",
        "description": "Ice pellets",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "338",
        "description": "Heavy snow",
        "day_icon": "wi_day_snow",
        "night_icon": "wi_night_snow"
    },
    {
        "code": "335",
        "description": "Patchy heavy snow",
        "day_icon": "wi_day_snow",
        "night_icon": "wi_night_snow"
    },
    {
        "code": "332",
        "description": "Moderate snow",
        "day_icon": "wi_day_snow",
        "night_icon": "wi_night_snow"
    },
    {
        "code": "329",
        "description": "Patchy moderate snow",
        "day_icon": "wi_day_snow",
        "night_icon": "wi_night_snow"
    },
    {
        "code": "326",
        "description": "Light snow",
        "day_icon": "wi_day_snow",
        "night_icon": "wi_night_snow"
    },
    {
        "code": "323",
        "description": "Patchy light snow",
        "day_icon": "wi_day_snow",
        "night_icon": "wi_night_snow"
    },
    {
        "code": "320",
        "description": "Moderate or heavy sleet",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "317",
        "description": "Light sleet",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "314",
        "description": "Moderate or Heavy freezing rain",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "311",
        "description": "Light freezing rain",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "308",
        "description": "Heavy rain",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "305",
        "description": "Heavy rain at times",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "302",
        "description": "Moderate rain",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "299",
        "description": "Moderate rain at times",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "296",
        "description": "Light rain",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "293",
        "description": "Patchy light rain",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "284",
        "description": "Heavy freezing drizzle",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "281",
        "description": "Freezing drizzle",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "266",
        "description": "Light drizzle",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "263",
        "description": "Patchy light drizzle",
        "day_icon": "wi_day_rain",
        "night_icon": "wi_night_rain"
    },
    {
        "code": "260",
        "description": "Freezing fog",
        "day_icon": "wi_day_fog",
        "night_icon": "wi_night_fog"
    },
    {
        "code": "248",
        "description": "Fog",
        "day_icon": "wi_day_fog",
        "night_icon": "wi_night_fog"
    },
    {
        "code": "230",
        "description": "Blizzard",
        "day_icon": "wi_day_snow_thunderstorm",
        "night_icon": "wi_night_snow_thunderstorm"
    },
    {
        "code": "227",
        "description": "Blowing snow",
        "day_icon": "wi_day_snow",
        "night_icon": "wi_night_snow"
    },
    {
        "code": "200",
        "description": "Thundery outbreaks in nearby",
        "day_icon": "wi_day_thunderstorm",
        "night_icon": "wi_night_thunderstorm"
    },
    {
        "code": "185",
        "description": "Patchy freezing drizzle nearby",
        "day_icon": "wi_day_cloudy",
        "night_icon": "wi_night_cloudy"
    },
    {
        "code": "182",
        "description": "Patchy sleet nearby",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "179",
        "description": "Patchy snow nearby",
        "day_icon": "wi_day_sleet",
        "night_icon": "wi_night_sleet"
    },
    {
        "code": "176",
        "description": "Patchy rain nearby",
        "day_icon": "wi_day_showers",
        "night_icon": "wi_night_showers"
    },
    {
        "code": "143",
        "description": "Mist",
        "day_icon": "wi_day_haze",
        "night_icon": "wi_night_haze"
    },
    {
        "code": "122",
        "description": "Overcast",
        "day_icon": "wi_day_cloudy",
        "night_icon": "wi_night_cloudy",
        "video":"cloudy.mp4"
    },
    {
        "code": "119",
        "description": "Cloudy",
        "day_icon": "wi_day_cloudy",
        "night_icon": "wi_night_cloudy"
    },
    {
        "code": "116",
        "description": "Partly Cloudy",
        "day_icon": "wi_day_sunny",
        "night_icon": "wi_night_clear"
    },
    {
        "code": "113",
        "description": "Clear/Sunny",
        "day_icon": "wi_day_sunny",
        "night_icon": "wi_night_clear"
    }
]